export enum HDREncodeFormat{
    NONE,
    RGBM,
    RGBD
   
}